<template>
    <div >

        <HomeAdmin v-if="$store.state.user.access_nivel != 1"/>
        <HomeUser v-else/>


    </div>
</template>

<script>
import HomeAdmin from "./HomeAdmin.vue";
import HomeUser from "./HomeUser.vue";
import "vue-loading-overlay/dist/vue-loading.css";

export default {

    components: {
        HomeAdmin,
        HomeUser
    },
};
</script>




// WEBPACK FOOTER //
// src/components/Report/Index.vue